<template>
  <Page title="Absenzenwesen" color="info">
    <v-btn
      color="success"
      fab
      fixed
      bottom
      right
      :to="{ name: 'JustificationStudentEdit', params: { justificationId: 0 } }"
      ><v-icon>mdi-plus</v-icon></v-btn
    >
    <Student :id="$_profilePerson.id" />
  </Page>
</template>
<script>
import { defineComponent } from "vue";
import Student from "./Student/indexStudent.vue";

export default defineComponent({
  components: {
    Student,
  },

  data() {
    return {
      items: [],
    };
  },
});
</script>
